import { atom } from 'jotai';

import { FilePageInfo, HistoryPageInfo, Tab } from './types';

export const filePageInfoState = atom<FilePageInfo>({
  patientId: null,
  page: 1,
  totalPage: 1,
  perPage: 10,
  filter: { sent: true, received: true },
});

export const historyPageInfoState = atom<HistoryPageInfo>({
  patientId: null,
  page: 1,
  totalPage: 1,
  perPage: 15,
});

export const tabState = atom<Tab>({
  type: 'reception',
});
